import { ReactNode } from 'react';
import Text from '@/storybook/components/Text/Text';
import { BannerSlotKeys } from '../types';
import { Slot, SlotProps } from './Slot';
import cx from 'classnames';
import styles from '../PageBanner.module.css';

interface TitleSlotProps extends Partial<SlotProps> {
  clamped?: boolean;
  clampOnScroll?: boolean;
  titleAccessory?: ReactNode;
}

const Title = ({ clamped, clampOnScroll = true, titleAccessory, children, ...rest }: TitleSlotProps) => (
  <Slot id={BannerSlotKeys.Title} {...rest}>
    <Text
      as="h1"
      className={cx(styles.title, {
        [styles.clamped]: clamped,
        [styles.noClampOnScroll]: !clampOnScroll,
      })}
    >
      <span className={styles.titleText}>{children}</span>
      {titleAccessory && <span className={styles.titleAccessory}>{titleAccessory}</span>}
    </Text>
  </Slot>
);

export default Title;
